"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6658],{

/***/ 22284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12963);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);


var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var schemaJson = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: []
    };
    var formatJSON = function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": "".concat(breadcrumb.url),
                name: "".concat(breadcrumb.content)
            }
        };
    };
    var createBreadcrumbSchema = function() {
        schemaJson.itemListElement = breadcrumbs.map(function(breadcrumb, index) {
            return formatJSON(breadcrumb, index);
        }) || [];
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: breadcrumbs.map(function(param, index) {
                    var content = param.content, url = param.url;
                    return index + 1 !== breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "body2",
                        children: content
                    }, content) || index + 1 === breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        role: "heading",
                        variant: "body2",
                        children: content
                    }, content);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                "data-testid": "breadcrumbListSchema",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 99014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ProfilePageSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ProfilePageSchema = function(param) {
    var displayName = param.displayName, description = param.description, imageURL = param.imageURL;
    var profilePageSchema = {
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        mainEntity: {
            "@type": "Person",
            name: displayName,
            description: description,
            image: imageURL
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        "data-testid": "profilePageSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(profilePageSchema)
        }
    });
};



/***/ }),

/***/ 94989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56721);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53340);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69417);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61659);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);






var CaregiverZipCodeCTA = function(param) {
    var enrollmentURL = param.enrollmentURL, serviceShortName = param.serviceShortName;
    var isEmbraceTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isEmbraceTheme;
    var zipCodeRegex = /^\d{0,5}$/;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), zip = ref[0], setZip = ref[1];
    var enrollmentLink = zip ? "".concat(enrollmentURL, "&zipcode=").concat(zip) : "".concat(enrollmentURL);
    var onZipCodeChange = function(e) {
        if (!zipCodeRegex.test(e.target.value)) {
            return;
        }
        setZip(e.target.value);
    };
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: "Start matching",
            cta_type: "button"
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    var handleKeyUp = function(e) {
        if (e.key === "Enter") {
            globalThis.location.href = "".concat(enrollmentLink);
            handleCtaBtn();
        }
    };
    var headline = function() {
        var vertical = "";
        if (serviceShortName === "cc") {
            vertical = "child care";
        } else if (serviceShortName === "sc") {
            vertical = "senior care";
        } else if (serviceShortName === "hk") {
            vertical = "housekeepers";
        } else if (serviceShortName === "tu") {
            vertical = "tutors";
        } else if (serviceShortName === "pc") {
            vertical = "pet care";
        } else if (serviceShortName === "cg") {
            vertical = "personal services";
        } else if (serviceShortName === "sn") {
            vertical = "special needs";
        }
        return "Find trusted ".concat(vertical, " in your area");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            backgroundColor: "background.grey",
            display: "flex",
            flexDirection: {
                xs: "column",
                sm: "row"
            },
            alignItems: "center",
            justifyContent: isEmbraceTheme ? "space-between" : undefined,
            mt: {
                sm: 4
            },
            py: isEmbraceTheme ? 3 : 2,
            borderRadius: {
                md: "16px"
            }
        },
        "data-testid": "caregiver-zip-code-cta",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: {
                    mr: {
                        sm: isEmbraceTheme ? 6 : 4
                    },
                    ml: {
                        lg: isEmbraceTheme ? 0 : 2
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: isEmbraceTheme ? "h3" : "h2",
                        mb: 1,
                        children: headline()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: isEmbraceTheme ? "body3" : "body2",
                        mb: 2,
                        children: "Enter a zip code to get matched with caregivers that meet your needs"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: {
                        xs: "space-between",
                        sm: "flex-start"
                    },
                    width: {
                        xs: "100%",
                        sm: "auto"
                    },
                    pb: 1
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        autoFocus: true,
                        placeholder: "Enter Zip Code",
                        onKeyUp: handleKeyUp,
                        onChange: onZipCodeChange,
                        value: zip,
                        InputProps: {
                            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                position: "start",
                                sx: {
                                    m: 0
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                            })
                        },
                        sx: {
                            height: "48px",
                            "& .MuiInputBase-root": {
                                maxWidth: "183px",
                                py: 0,
                                px: 1
                            },
                            mr: {
                                sm: isEmbraceTheme ? 3 : 2
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        color: "primary",
                        variant: isEmbraceTheme ? "outlined" : "contained",
                        size: "medium",
                        sx: {
                            maxWidth: "156px",
                            minWidth: "0",
                            height: "40px",
                            fontSize: isEmbraceTheme ? "body2.fontSize" : "1.125rem",
                            p: 0,
                            px: {
                                sm: 2
                            }
                        },
                        onClick: handleCtaBtn,
                        href: enrollmentLink,
                        rel: "nofollow",
                        children: "Start matching"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaregiverZipCodeCTA);


/***/ }),

/***/ 37187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);



var useAmplitudeTracking = function(param) {
    var deviceChar = param.deviceChar, testName = param.testName, hasCareCheck = param.hasCareCheck, serviceShortName = param.serviceShortName, hasAiBio = param.hasAiBio;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var amplitudeDataForProfileViewed = {
            caregiverType: hasCareCheck ? "CareChecked" : undefined,
            has_ai_bio: hasAiBio
        };
        if (testName) {
            var amplitudeDataForTestExposure = {
                test_name: testName,
                test_variant: "1",
                service_short_name: serviceShortName
            };
            (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .AmplitudeEvent.testExposure */ .Sj.testExposure, amplitudeDataForTestExposure);
        }
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .AmplitudeEvent.providerProfileViewed */ .Sj.providerProfileViewed, amplitudeDataForProfileViewed);
    }, [
        testName,
        hasCareCheck,
        hasAiBio,
        serviceShortName
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var pageProperties = {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_2__/* .ScreenName.PROVIDER */ .CG.PROVIDER,
            screen_template: _constants__WEBPACK_IMPORTED_MODULE_2__/* .ScreenTemplate.PROVIDER */ .Yj.PROVIDER,
            seo_page_id: _constants__WEBPACK_IMPORTED_MODULE_2__/* .SeoPageId.PROVIDER */ .IH.PROVIDER,
            slots: _constants__WEBPACK_IMPORTED_MODULE_2__/* .TealiumSlot.VISITOR */ .vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .setPagePropertiesFromData */ .UP)(pageProperties);
            (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .setDeviceDataFromHeaders */ .xF)(deviceChar);
        }
    }, [
        deviceChar
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAmplitudeTracking);


/***/ }),

/***/ 54847:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var useMetaTags = function(providerMetadata) {
    var description = providerMetadata.description, keywords = providerMetadata.keywords, title = providerMetadata.title, image = providerMetadata.image, noIndexMetaTag = providerMetadata.noIndexMetaTag;
    var tags = [
        {
            name: "description",
            content: description
        },
        {
            name: "keywords",
            content: keywords
        },
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0"
        },
        {
            name: "verify-v1",
            content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
        },
        {
            name: "twitter:card",
            content: "summary"
        },
        {
            name: "twitter:description",
            content: description
        },
        {
            name: "twitter:title",
            content: title
        },
        {
            name: "twitter:site",
            content: "@CareDotCom"
        },
        {
            name: "twitter:image",
            content: image
        },
        {
            name: "twitter:image:alt",
            content: description
        },
        {
            name: "twitter:creator",
            content: "@CareDotCom"
        },
        {
            name: "og:title",
            property: "og:title",
            content: title
        },
        {
            name: "og:type",
            property: "og:type",
            content: "website"
        },
        {
            name: "og:image",
            property: "og:image",
            content: image
        },
        {
            name: "og:image:width",
            property: "og:image:width",
            content: "1200"
        },
        {
            name: "og:image:height",
            property: "og:image:height",
            content: "630"
        },
        {
            name: "og:description",
            property: "og:description",
            content: description
        },
        {
            name: "fb:page_id",
            property: "fb:page_id",
            content: "6030284861"
        }, 
    ];
    // Conditionally add noindex meta tag
    if (noIndexMetaTag) {
        tags.push({
            name: "robots",
            content: "noindex"
        });
    }
    return tags;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMetaTags);


/***/ }),

/***/ 12800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


var MetaHead = function(param) {
    var pageTitle = param.pageTitle, metaTags = param.metaTags, seoProfileUrl = param.seoProfileUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: pageTitle
            }),
            metaTags.map(function(metaTag) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: metaTag.name,
                    property: metaTag.property,
                    content: metaTag.content
                }, metaTag.name);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: seoProfileUrl
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaHead);


/***/ }),

/***/ 85715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_generateEnrollmentUrl; }
});

;// CONCATENATED MODULE: ./src/utils/getServerSidePropsUtil.ts
// Write tests for these and use them in getServerSideProps
var getSegmentUrl = function(query) {
    var ref;
    var segmentURL = (ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1;
    var pageStringArr = (ref1 = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.split("-page")) !== null && ref1 !== void 0 ? ref1 : ""; // remove anything after -page
    return "/".concat(pageStringArr[0]);
};
var getVerticalUrl = function(query) {
    var ref;
    var verticalURL = (ref = query.vertical) === null || ref === void 0 ? void 0 : ref.toString();
    return "".concat(verticalURL);
};
var getPageNumber = function(query) {
    var ref;
    var segmentURL = ((ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString()) || "";
    var page = 1;
    var urlPageNumber = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.replace(/^\D+/g, ""); // find number
    if (urlPageNumber.length > 0) {
        page = Number(urlPageNumber);
    }
    return page;
};

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/utils/generateEnrollmentUrl.ts


// eslint-disable-next-line complexity
var generateEnrollmentUrl = function(param) {
    var router = param.router, serviceIdForMember = param.serviceIdForMember, tmp = param.serviceId, argServiceId = tmp === void 0 ? "" : tmp, _serviceShortName = param.serviceShortName, serviceShortName = _serviceShortName === void 0 ? "" : _serviceShortName, serviceProfileId = param.serviceProfileId, _segmentId = param.segmentId, segmentId = _segmentId === void 0 ? "" : _segmentId, _directoryFirstExperience = param.directoryFirstExperience, directoryFirstExperience = _directoryFirstExperience === void 0 ? false : _directoryFirstExperience, _isAdultCareEnrollment = param.isAdultCareEnrollment, isAdultCareEnrollment = _isAdultCareEnrollment === void 0 ? false : _isAdultCareEnrollment;
    var serviceId = argServiceId !== "" ? argServiceId : constants/* SEO_SERVICE_SHORT_NAMES */.Mk[serviceShortName];
    var serviceDetails = constants/* SEO_SERVICE_DETAILS */.Jm[serviceId];
    var fromSeoPage = "fromSeoPage=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.fromSeoPage */.BC.fromSeoPage);
    var serviceIdParam = "serviceId=".concat(serviceId);
    var memberServiceId = serviceIdForMember !== null && serviceIdForMember !== void 0 ? serviceIdForMember : constants/* SEO_SERVICE_DETAILS */.Jm[serviceId].serviceIdForMemberVal;
    var segmentUrl = (router === null || router === void 0 ? void 0 : router.query.segment) ? getSegmentUrl(router.query) : segmentId;
    if (memberServiceId === memberServiceId.toUpperCase()) {
        memberServiceId = memberServiceId.toLowerCase();
    }
    var adultCareSegments = [
        "/adult-care",
        "/special-needs-adult-care",
        "/post-surgery-care"
    ];
    if (serviceIdForMember === "childCareLocation") {
        memberServiceId = "dayCare";
    }
    if (adultCareSegments.includes(segmentUrl) || isAdultCareEnrollment) {
        memberServiceId = "adultCare";
    }
    var serviceIdForMemberParam = "serviceIdForMember=".concat(memberServiceId);
    var source = "source=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.source */.BC.source);
    var pageSource = "pageSource=".concat(serviceDetails.pageSource);
    var visitedServiceProfileId = serviceProfileId ? "&visitedServiceProfileId=".concat(serviceProfileId) : "";
    var enrollmentQueryParams = "".concat(fromSeoPage, "&").concat(serviceIdParam, "&").concat(serviceIdForMemberParam, "&").concat(source, "&").concat(pageSource).concat(visitedServiceProfileId);
    var enrollmentType = memberServiceId.slice(memberServiceId.length - 3) === "Job" ? "provider" : "seeker";
    if (isAdultCareEnrollment) {
        return "/app/enrollment/".concat(enrollmentType, "/ac?").concat(enrollmentQueryParams);
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS */.u2.CARE_GIGS) {
        return "/app/vhp/care-kind?".concat(enrollmentQueryParams);
    }
    if (directoryFirstExperience && serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION) {
        return "/app/business-search?".concat(enrollmentQueryParams);
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.HOUSING_LOCATION */.u2.HOUSING_LOCATION) {
        return "/app/business-search/senior-care?".concat(enrollmentQueryParams, "&enrollment=true");
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS */.u2.SPECIAL_NEEDS) {
        return "/app/enrollment/".concat(enrollmentType, "/cc?").concat(enrollmentQueryParams);
    }
    // careGigsJob and specialNeedsJob to vertical-triage enrollment flow since they dont have a dedicated flow.
    // The multi-vertical flow will be used on "/jobs, /full-time-jobs, and /part-time-jobs" segmentation pages (these are under childCareJobs):
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS_JOB */.u2.CARE_GIGS_JOB || serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS_JOB */.u2.SPECIAL_NEEDS_JOB || segmentUrl === "/jobs" || segmentUrl === "/full-time-jobs" || segmentUrl === "/part-time-jobs") {
        return "/app/vhp/vertical-triage?memberType=sitter&".concat(enrollmentQueryParams);
    }
    // Job search enrollment URL
    if (enrollmentType === "provider") {
        return "/app/enrollment/provider/mv/".concat(serviceId, "?").concat(enrollmentQueryParams);
    }
    if (serviceId === constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE && serviceIdForMember === constants/* ServiceIdForMember.HOUSING_LOCATION */.u2.HOUSING_LOCATION) {
        // This is specific to Senior Assisted Living Communities( In facility care or OOH)
        return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "/").concat(constants/* SC_SEEKER_IN_FACILITY_ROUTES.WHO_NEEDS_CARE */.oF.WHO_NEEDS_CARE, "?").concat(enrollmentQueryParams);
    }
    return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "?").concat(enrollmentQueryParams);
};
/* harmony default export */ var utils_generateEnrollmentUrl = (generateEnrollmentUrl);


/***/ }),

/***/ 56897:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getAvailability = function(availability) {
    if (!availability) return "";
    if (availability === "FULL_TIME") return "Full-time";
    return "Part-time";
};
var getProviderMetadata = function(data) {
    var lowerCaseServiceName = data.serviceName.toLowerCase();
    var availability = getAvailability(data.availability);
    var location = data.address ? "".concat(data.address.city, ", ").concat(data.address.state) : null;
    var title = "Book ".concat(data.serviceName, " Services ").concat(location === null ? "" : "in ".concat(location), " with ").concat(data.displayName, " ").concat(data.hourlyRate ? "from $".concat(data.hourlyRate, "/hr") : "", " ");
    var description = "Looking to hire ".concat(lowerCaseServiceName, " services ").concat(location === null ? "" : "in ".concat(location), "? Look no further! ").concat(data.displayName, " ").concat(data.yearsOfExperience === null || data.yearsOfExperience === 0 ? "" : "with ".concat(data.yearsOfExperience, " years of experience,"), " offers ").concat(lowerCaseServiceName, " services starting at $").concat(data.hourlyRate, "/hr. Read reviews and contact ").concat(data.firstName, " today.");
    var keywords = "".concat(data.displayName, ", ").concat(availability, " Caregiving Provider, ").concat(location);
    var image = data.image;
    // Determine if meta robots tag should be noindex
    var _isPremium = data.isPremium, isPremium = _isPremium === void 0 ? false : _isPremium, _bio = data.bio, bio = _bio === void 0 ? "" : _bio, _totalReviews = data.totalReviews, totalReviews = _totalReviews === void 0 ? 0 : _totalReviews;
    var ref;
    var noIndexMetaTag = !isPremium && ((ref = bio === null || bio === void 0 ? void 0 : bio.length) !== null && ref !== void 0 ? ref : 0) < 300 && totalReviews === 0;
    var providerMetadata = {
        title: title,
        description: description,
        keywords: keywords,
        image: image,
        noIndexMetaTag: noIndexMetaTag
    };
    return providerMetadata;
};
/* harmony default export */ __webpack_exports__["Z"] = (getProviderMetadata);


/***/ }),

/***/ 7772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUserInitials; }
/* harmony export */ });
/**
 * Extracts and formats the initials from a display name.
 *
 * @param displayName - The full name of the user
 * @returns The uppercase initials of the user's name
 *
 * @example
 * // Returns "JD"
 * getUserInitials("John Doe");
 *
 * @example
 * // Returns "JD"
 * getUserInitials("  John   Doe  ");
 *
 * @example
 * // Returns "ABC"
 * getUserInitials("Alice Bob Charlie");
 */ var getUserInitials = function(displayName) {
    return displayName.trim().split(" ").filter(function(name) {
        return name.length > 0;
    }).map(function(name) {
        return name[0] || "";
    }).join("").toUpperCase();
};


/***/ }),

/***/ 94627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58939);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);


var mapQualitiesAndServices = function(data) {
    if (data) {
        // Convert the keys of the object into an array of strings, only including ones that return true
        var attributesArray = Object.keys(data).filter(function(k) {
            return data[k];
        });
        // Convert key strings from camelCase to Sentence case
        attributesArray = attributesArray.map(function(key) {
            if (Object.prototype.hasOwnProperty.call(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CAREGIVER_SERVICES */ .tY, key)) {
                return (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CAREGIVER_SERVICES */ .tY[key]);
            }
            if (Object.prototype.hasOwnProperty.call(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CAREGIVER_QUALITIES */ .cY, key)) {
                return _constants__WEBPACK_IMPORTED_MODULE_0__/* .CAREGIVER_QUALITIES */ .cY[key];
            }
            if (Object.prototype.hasOwnProperty.call(_constants__WEBPACK_IMPORTED_MODULE_0__/* .MERCHANDIZED_JOB_INTERESTS */ .xg, key)) {
                return (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants__WEBPACK_IMPORTED_MODULE_0__/* .MERCHANDIZED_JOB_INTERESTS */ .xg[key]);
            }
            if (Object.prototype.hasOwnProperty.call(_constants__WEBPACK_IMPORTED_MODULE_0__/* .JOB_PREFERENCES */ .wu, key)) {
                return _constants__WEBPACK_IMPORTED_MODULE_0__/* .JOB_PREFERENCES */ .wu[key];
            }
            return key;
        });
        // Remove the __typename index
        attributesArray.shift();
        // Remove duplicate fields
        attributesArray = attributesArray.filter(function(element, i) {
            return i === attributesArray.indexOf(element);
        });
        return attributesArray;
    }
    return [];
};
/* harmony default export */ __webpack_exports__["Z"] = (mapQualitiesAndServices);


/***/ }),

/***/ 32150:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var payRangeHelper = function(hourlyRateTo, hourlyRateFrom) {
    var showUnit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ((hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0 && Number(hourlyRateTo) < 10) {
        return "< $10/hr";
    }
    if ((hourlyRateFrom === null || hourlyRateFrom === void 0 ? void 0 : hourlyRateFrom.length) > 0 && (hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0) {
        var str = "";
        if (Number(hourlyRateFrom) === Number(hourlyRateTo)) {
            str = "$".concat(hourlyRateFrom);
        } else if (Number(hourlyRateFrom) === 0) {
            str = ">$".concat(hourlyRateTo);
        } else {
            str = "$".concat(hourlyRateFrom, "-").concat(hourlyRateTo);
        }
        return showUnit ? "".concat(str, "/hr") : str;
    }
    if ((hourlyRateFrom === null || hourlyRateFrom === void 0 ? void 0 : hourlyRateFrom.length) > 0) {
        return "> $".concat(hourlyRateFrom);
    }
    return (hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0 ? "< $".concat(hourlyRateTo) : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (payRangeHelper);


/***/ })

}]);